/* this file is transformed by vux-loader */
/* eslint-disable */
//
//
//
//
//
export default {
  name: 'compontent',
  abstract: true,
  props: {
    name: {
      type: String,
      default: 'slide-right'
    }
  }
};